import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-xs" }
const _hoisted_2 = {
  key: 0,
  class: "flex gap-1"
}
const _hoisted_3 = { class: "w-[130px]" }
const _hoisted_4 = {
  key: 1,
  class: "flex gap-1"
}
const _hoisted_5 = { class: "w-[130px]" }
const _hoisted_6 = { class: "flex gap-1" }
const _hoisted_7 = { class: "w-[130px]" }

import { format } from "date-fns";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import OaiTooltip from "shared/components/other/OaiTooltip.vue";
import { CriticalPathDelta } from "shared/types/CriticalPath";
import {
  useFormattedDelta,
  useDeltaTextClass,
  useDeltaTextWithBackgroundClass,
} from "../composables";

const dateFormat = "dd.MM.yyyy";


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalPathDelay',
  props: {
    deltaForNode: {},
    cls: {},
    noBackgroundHighlight: { type: Boolean },
    style: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t } = useI18n();

const delta = computed(() => props.deltaForNode.workingDays);
const formattedDelta = useFormattedDelta(delta);

const lastFinishedTextClass = useDeltaTextClass(delta);
const lastFinishedTextWithBackgroundClass = useDeltaTextWithBackgroundClass(delta);

const lastFinishedClass = computed(() =>
  props.noBackgroundHighlight
    ? lastFinishedTextClass.value
    : lastFinishedTextWithBackgroundClass.value,
);

return (_ctx: any,_cache: any) => {
  return (delta.value !== null)
    ? (_openBlock(), _createBlock(OaiTooltip, {
        key: 0,
        cls: [
      _ctx.cls,
      'text-xs px-2 py-0.5 rounded-full whitespace-nowrap cursor-pointer',
      lastFinishedClass.value,
    ],
        style: _normalizeStyle(_ctx.style),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
      }, {
        tooltip: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.deltaForNode.plannedEvent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("analytics.critical_path.planned_end")) + ":", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(format)(_ctx.deltaForNode.plannedEvent.end, dateFormat)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.deltaForNode.endDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.deltaForNode.projectedEndDate
                ? _unref(t)("analytics.critical_path.projected_end")
                : _unref(t)("analytics.critical_path.actual_end")) + ": ", 1),
                  _createElementVNode("div", null, _toDisplayString(_unref(format)(_ctx.deltaForNode.endDate, dateFormat)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("working_day.working_day")) + ":", 1),
              _createElementVNode("div", null, _toDisplayString(_unref(formattedDelta)), 1)
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(formattedDelta)) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")) + " ", 1)
        ]),
        _: 1
      }, 8, ["cls", "style"]))
    : _createCommentVNode("", true)
}
}

})